<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.755 9.425C5.72675 9.413 5.69992 9.39791 5.675 9.38L2.185 6.38C2.04924 6.26389 1.98574 6.08417 2.01841 5.90854C2.05109 5.73291 2.17497 5.58806 2.34341 5.52854C2.51185 5.46902 2.69924 5.50389 2.835 5.62L5.5 7.91V2C5.5 1.72386 5.72386 1.5 6 1.5C6.27614 1.5 6.5 1.72386 6.5 2V7.91L9.175 5.62C9.38487 5.44051 9.70051 5.46513 9.88 5.675C10.0595 5.88487 10.0349 6.20051 9.825 6.38L6.325 9.38C6.30008 9.39791 6.27325 9.413 6.245 9.425L6.185 9.465C6.0662 9.51231 5.9338 9.51231 5.815 9.465L5.755 9.425ZM11 10.5V9.5C11 9.22386 10.7761 9 10.5 9C10.2239 9 10 9.22386 10 9.5V10.465C9.95555 10.4891 9.90556 10.5012 9.855 10.5H2.145C2.09444 10.5012 2.04445 10.4891 2 10.465V9.5C2 9.22386 1.77614 9 1.5 9C1.22386 9 1 9.22386 1 9.5V10.5C1.04533 11.0897 1.55458 11.5344 2.145 11.5H9.855C10.4454 11.5344 10.9547 11.0897 11 10.5Z"
      fill="#ffffff"
    />
  </svg>
</template>
<script>
export default {};
</script>
<style>
</style>